<template>
  <button
    type="button"
    class="btn btn-primary btn-floating"
    id="btn-back-to-top"
    @click="backToTop"
    @keyup.enter="backToTop"
  >
    <p style="color: white; font-size: 10pt" class="mb-0">
      {{ btnText }}
    </p>
  </button>
</template>

<script>
export default {
  props: {
    btnText: {
      type: String,
      default: "Gå til top",
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  updated() {
    this.handleScroll();
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      const toTopBtn = document.getElementById("btn-back-to-top");
      const productCardList = document.getElementsByClassName(
        "product-card-list"
      )[0];
      const paginationContainer = document.getElementsByClassName(
        "pagination-container"
      )[0];

      if (toTopBtn && productCardList && paginationContainer) {
        // backToTopBtn should be visible when list view hits top of productCardList
        let displayStart = productCardList.offsetTop;
        // backToTopBtn should be hidden when it hits bottom of pagination container
        let displayEnd =
          productCardList.offsetTop + // account for start of list view
          productCardList.offsetHeight - // account for height of list view
          0.8 * document.documentElement.clientHeight + // account for backToTopBtn starting at 20vh - change if CSS "bottom: 20vh" is changed!
          paginationContainer.offsetHeight; // account for pagination component

        if (
          (document.body.scrollTop > displayStart &&
            document.body.scrollTop < displayEnd) ||
          (document.documentElement.scrollTop > displayStart &&
            document.documentElement.scrollTop < displayEnd)
        ) {
          toTopBtn.style.display = "block";
        } else {
          toTopBtn.style.display = "none";
        }
      }
    },
  },
};
</script>

<style lang="scss">
#btn-back-to-top {
  position: fixed;
  bottom: 20vh;
  right: -20px;
  display: none;
  z-index: 1;
  transform: rotate(-90deg);
  border: 2px solid white;
  &:hover,
  &:focus {
    transform: rotate(-90deg) scale(1.05);
  }
}
</style>
